import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResultInfoGenericDto } from '../dto/ResultInfoDto';
import { FormToJsonBlService } from './form-to-json-bl.service';
import { CreateResultDto } from '../dto/create-result-dto';

@Injectable({
  providedIn: 'root'
})
export class OznameniSberuService {

  constructor(
    private http: HttpClient,
    private formToJsonBlService: FormToJsonBlService
  ) { }

  private apiOznameniSberuCreate: string = "api/OznameniSberu/Create";
  private apiOznameniSberuGet: string = "api/OznameniSberu/Get";

  /**
   * Vytvoří nové oznámení o sběru
   * @param jsonData
   */
  createNew(jsonData: any): Observable<ResultInfoGenericDto<CreateResultDto>> {
    let jsonString = this.formToJsonBlService.convert(jsonData);
    let httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    return this.http.post<ResultInfoGenericDto<CreateResultDto>>(this.apiOznameniSberuCreate, jsonString, httpOptions);
  };

  /**
   * Vrátí dto foprmuláře
   * @param zadostId
   * @param token
   */
  get(zadostId: number, token: string): Observable<ResultInfoGenericDto<any>> {
    return this.http.get<ResultInfoGenericDto<any>>(this.apiOznameniSberuGet + "/" + zadostId + "/" + token);
  };

}
